<template>
    <Card>
        <IntegrationOrdersTable :integration="integration" />
    </Card>
</template>
<script>
import Card from '../../../../../../../../resources/js/components/new/CardComponent.vue';
import IntegrationOrdersTable from './IntegrationOrdersTable.vue';

export default {
    name: "OrdersListPage",
    components: {
        Card, IntegrationOrdersTable
    },
    props: {
        integration: {
            type: Object,
            required: true
        }
    }
}
</script>